import React from 'react';

import { Loader } from 'components/common/Loader/Loader';

import './PageLoading.scss';

/**
 * What shows while a page's chunk loads, the first time the page is opened (#226). A cached
 * chunk resolves before this is painted, so it is only seen on a slow first visit.
 */
export const PageLoading = () => (
  <div className="PageLoading" role="status" aria-busy="true">
    <Loader />
  </div>
);
